<template>
    <v-btn class="d-block pa-0 ma-0 w-100 load-more" elevation="0" variant="plain" :loading="props.loading">
        <div class="d-flex text-center text-size-lg text-primary font-weight-medium w-100">
            <v-divider :thickness="2" class="flex-1-0-0 align-self-center"></v-divider>
            <span class="flex-0-0-1 align-self-center px-4">{{ t(props.text) }}</span>
            <v-divider class="flex-1-0-0 align-self-center" :thickness="2"></v-divider>
        </div>
    </v-btn>
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { ILoadMoreButton } from '../types';

const { t } = useI18n();

const props = withDefaults(defineProps<ILoadMoreButton>(), {
    text: 'startPage.loadMore',
    loading: false
});
</script>
